import RichSelect from "legacy/RichSelect"
import PropTypes from "prop-types"
import React from "react"

class ReservationLabelSelect extends React.Component {
  constructor(args) {
    super(args)
    this.state = {
      reservationLabelId: this.props.reservationLabelId || "",
      reservationLabels: null,
      savingReservationLabelId: false,
      errorMessage: "",
    }
    this.updateReservationLabelId = this.updateReservationLabelId.bind(this)
  }

  componentDidMount() {
    if (this.state.reservationLabels == null) {
      $.get(this.props.manageReservationLabelsPath, (data) => {
        this.setState({ reservationLabels: data })
      }).fail((data) => {
        this.setState({
          reservationLabels: [],
          errorMessage:
            "Failed to load labels. Please reload the page and try again.",
        })
      })
    }
  }

  updateReservationLabelId(e) {
    const selectedReservationLabelId = e.target.value
    const previouslySelectedReservationLabelId = this.state.reservationLabelId

    if (previouslySelectedReservationLabelId === selectedReservationLabelId) {
      return
    }

    this.setState({
      reservationLabelId: selectedReservationLabelId,
      savingReservationLabelId: true,
      errorMessage: "",
    })

    const params = {
      reservation_label_id: selectedReservationLabelId,
    }

    $.ajax({
      url: this.props.manageReservationReservationLabelPath,
      type: "PATCH",
      dataType: "json",
      contentType: "application/json",
      data: JSON.stringify(params),
      success: () => {
        this.setState({ savingReservationLabelId: false })
      },
      error: (data) => {
        const errorMessage =
          data.responseJSON.errors ||
          "Failed to update reservation. Please try again."
        this.setState({
          reservationLabelId: previouslySelectedReservationLabelId,
          savingReservationLabelId: false,
          errorMessage,
        })
      },
    })
  }

  renderReservationLabelSelect() {
    return (
      <RichSelect
        name="reservationLabelId"
        nilable={true}
        options={this.buildLabelOptions()}
        value={this.state.reservationLabelId}
        onChange={this.updateReservationLabelId}
      />
    )
  }

  buildLabelOptions() {
    const labels = [
      { id: "", label: "None", color: "dark-blue" },
      ...this.state.reservationLabels,
    ]
    return labels.map((label) => {
      label.content = (
        <span>
          <span
            className={`inline-block h-3 w-3 rl-bg-${label.color}-dark mr-1.5 rounded-full`}
          />
          {label.label}
        </span>
      )
      return label
    })
  }

  renderTextWithSpinner(text) {
    return (
      <div>
        {text} <i className="icon icon-spinner icon-spin ml-2 text-gray-600" />
      </div>
    )
  }

  renderSetupReservationLabelsText() {
    return (
      <div>
        Go to your{" "}
        <a
          href={this.props.manageMarinaMapsPath}
          target="_blank"
          rel="noreferrer"
        >
          Marina Map Settings
        </a>{" "}
        to setup labels.
      </div>
    )
  }

  errorMessageText() {
    return (
      <div className="inline text-xs text-red-600">
        {this.state.errorMessage}
      </div>
    )
  }

  render() {
    if (this.state.reservationLabels === null) {
      return this.renderTextWithSpinner("Loading")
    } else if (
      this.state.reservationLabels &&
      this.state.reservationLabels.length > 0
    ) {
      if (this.state.savingReservationLabelId) {
        return this.renderTextWithSpinner("Updating reservation label")
      } else {
        return (
          <div className="flex items-center">
            <div className="mr-5">{this.renderReservationLabelSelect()}</div>
            {this.state.errorMessage !== "" && this.errorMessageText()}
          </div>
        )
      }
    } else {
      if (this.state.errorMessage === "") {
        return this.renderSetupReservationLabelsText()
      } else {
        return this.errorMessageText()
      }
    }
  }
}

ReservationLabelSelect.propTypes = {
  reservationLabelId: PropTypes.string,
  manageReservationLabelsPath: PropTypes.string.isRequired,
  manageReservationReservationLabelPath: PropTypes.string.isRequired,
  manageMarinaMapsPath: PropTypes.string.isRequired,
}

ReservationLabelSelect.defaultProps = {
  reservationLabelId: "",
}

export default ReservationLabelSelect
